import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'trumpf_ch',
} as IModuleProps;
